<section class="page">
  <header class="page-header">
    <h2>Suivi des colis</h2>
    <p class="subtitle">Lance la vérification automatique des livraisons des capteurs et des retours.</p>
  </header>

  <section class="panel">
    <button type="button" (click)="runCheck()" [disabled]="running">
      {{ running ? 'Vérification en cours...' : 'Vérifier les livraisons' }}
    </button>

    @if (lastRunAt) {
      <p class="meta">Dernière exécution: {{ lastRunAt | date:'dd/MM/yyyy HH:mm:ss' }}</p>
    }

    @if (error) {
      <p class="error">{{ error }}</p>
    }
  </section>

  <section class="panel">
    <h3>Cartouches en cours de livraison</h3>
    @if (loadingCartouchesEnCours) {
      <p>Chargement des cartouches en cours...</p>
    } @else if (cartouchesEnCoursError) {
      <p class="error">{{ cartouchesEnCoursError }}</p>
    } @else if (cartouchesEnCours.length === 0) {
      <p>Aucune cartouche en cours de livraison.</p>
    } @else {
      <ul class="in-transit-list">
        @for (item of cartouchesEnCours; track item.id) {
          <li>
            <span class="cartouche-name">{{ item.nom }}</span>
            <span class="cartouche-status">{{ item.statut_livraison_nom }}</span>
          </li>
        }
      </ul>
    }
  </section>

  @if (result) {
    <section class="panel">
      <h3>Résultats</h3>
      <div class="stats-grid">
        <article>
          <span class="label">Cartouches marquées livrées</span>
          <strong>{{ result.markedCartouchesLivrees }}</strong>
        </article>
        <article>
          <span class="label">Appels API Laposte</span>
          <strong>{{ result.trackingCalls }}</strong>
        </article>
        <article>
          <span class="label">Erreurs</span>
          <strong>{{ result.errors.length }}</strong>
        </article>
      </div>
    </section>

    @if (result.errors.length > 0) {
      <section class="panel">
        <h3>Détail des erreurs</h3>
        <ul class="errors-list">
          @for (entry of result.errors; track $index) {
            <li>
              <span>Capteur #{{ entry.capteurId }} ({{ entry.step }})</span>
              <p>{{ entry.error }}</p>
            </li>
          }
        </ul>
      </section>
    }
  }
</section>
